import { ImageWrapper as _ImageWrapper } from "@/lib/styles";
import { P } from "@/lib/styles";
import styled from "styled-components";

export const OuterWrapper = styled.div`
  grid-column: 1 / -1;
  margin-bottom: 5rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-bottom: 0;
  }
`;

export const InnerWrapper = styled.div<{ $position?: string; $index: number }>`
  width: calc(100% * 3 / 4);
  margin-left: ${({ $position }) =>
    $position === "left" ? "0" : "calc(100% * 1/4)"};
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 50%;
    margin-left: ${({ $position }) => ($position === "left" ? "0" : "50%")};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: ${({ $index }) => ($index === 0 ? "0" : "-25%")};
    margin-bottom: ${({ $index }) => ($index === 0 ? "0" : "")};
  }
`;

export const Container = styled.div<{ $imageIsVertical?: boolean }>`
  position: relative;

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: ${({ $imageIsVertical }) =>
      $imageIsVertical ? "28.3125rem" : "28.3125rem"};
  }
`;

export const TextContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 1rem 1.25rem;
  }
`;

export const Heading = styled.h3`
  color: ${({ theme }) => theme.colors.red};
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.25rem;

  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }

  opacity: 0;
  .lines {
    opacity: 0;
    transform: translateY(20px);
  }
`;

export const Excerpt = styled(P)`
  opacity: 0;
  .lines {
    opacity: 0;
    transform: translateY(20px);
  }
`;
